export default __webpack_public_path__ + "static/media/ic_collapse.463f3c13.svg";